import { useCallback } from 'react'
import { vibeAgentLogger as logger } from 'v2/utils/logger'
import { getVibeAgentApi } from './api-registry'

/**
 * Send a Vibe Agent message from OUTSIDE the sidebar (title-bar "Test with
 * Vibe", homepage prompt hand-off). The run routes through the mounted
 * useVibeAgent instance via the api registry.
 */
export interface VibeSendOptions {
  workflowOverride?: string
}

export const useVibeSend = (): ((message: string, options?: VibeSendOptions) => void) => {
  return useCallback((message: string, options?: VibeSendOptions) => {
    const api = getVibeAgentApi()
    if (!api) {
      logger.error('[VIBE] send requested before the sidebar registered its api')
      return
    }
    api.send(message, { workflowOverride: options?.workflowOverride })
  }, [])
}
